import { lazy, type JSX, type LazyExoticComponent } from 'react';

import type { JsmJourneyBuilderUIActionProps } from './index';

export const JsmJourneyBuilderUIActionAsync: LazyExoticComponent<
	(props: JsmJourneyBuilderUIActionProps) => JSX.Element
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/jsm-journey-builder-actions" */ './index'
	).then((m) => ({ default: m.JsmJourneyBuilderUIAction })),
);
